var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isLoading)?_c('div',[_c('NewPasswordForgottenComponent',{attrs:{"axios":_vm.axios,"translations-prefix":_vm.translationsPrefix},on:{"change-password":function($event){return _vm.changePassword($event)}}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }